import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_IDENTIFICATION_IMAGE_DELETE_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_IDENTIFICATION_IMAGE_DELETE_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_IDENTIFICATION_IMAGE_DELETE_API_ID,
  ({ userId, identificationImageId }) => ({
    endpoint: `/api/admin/users/${userId}/identification-images/${identificationImageId}`,
    method: 'DELETE',
    isStay: true,
    isReload: true,
    notify: true,
  })
);

export default apiCall;
